import { render, staticRenderFns } from "./NewMessageNewFileDialog.vue?vue&type=template&id=c7a1ca3e&scoped=true"
import script from "./NewMessageNewFileDialog.vue?vue&type=script&lang=js"
export * from "./NewMessageNewFileDialog.vue?vue&type=script&lang=js"
import style0 from "./NewMessageNewFileDialog.vue?vue&type=style&index=0&id=c7a1ca3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a1ca3e",
  null
  
)

export default component.exports